module.exports = __webpack_public_path__ + "static/img/logo_sztqd.3c6d9c8.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/otherlogo/logo_sztqd.png
// module id = DL0h
// module chunks = 190